import { render, staticRenderFns } from "./InspectorSelectModal.vue?vue&type=template&id=279ea060&scoped=true&"
import script from "./InspectorSelectModal.vue?vue&type=script&lang=js&"
export * from "./InspectorSelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279ea060",
  null
  
)

export default component.exports